import { useContext } from "react";
import { EmbedComponentsContext } from "../context/embed-components-context";
export var useEmbedComponents = function () {
  return useContext(EmbedComponentsContext);
};